import { useState, useEffect } from 'react';
import axios from 'axios';
import { Mail, MessageSquare } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function EmailSmsSender({ contactId, campaignId, callId }) {
  const [mode, setMode] = useState('email'); // 'email' or 'sms'
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (campaignId) {
      fetchTemplates();
    }
  }, [campaignId, mode]);

  const fetchTemplates = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (mode === 'email') {
        const response = await axios.get(
          `${API_BASE}/dialer/campaigns/${campaignId}/email-templates`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setEmailTemplates(response.data);
      } else {
        const response = await axios.get(
          `${API_BASE}/dialer/campaigns/${campaignId}/sms-templates`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setSmsTemplates(response.data);
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  const handleSend = async () => {
    if (!selectedTemplate) return;

    setLoading(true);
    try {
      const token = localStorage.getItem('accessToken');
      const endpoint = mode === 'email'
        ? `${API_BASE}/dialer/contacts/${contactId}/send-email`
        : `${API_BASE}/dialer/contacts/${contactId}/send-sms`;
      
      await axios.post(
        endpoint,
        { template_id: selectedTemplate, call_id: callId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(`${mode === 'email' ? 'Email' : 'SMS'} sent successfully!`);
      setSelectedTemplate('');
    } catch (error) {
      console.error(`Error sending ${mode}:`, error);
      alert(`Failed to send ${mode}`);
    } finally {
      setLoading(false);
    }
  };

  const templates = mode === 'email' ? emailTemplates : smsTemplates;

  return (
    <div className="bg-white rounded-lg shadow p-4 space-y-3">
      <div className="flex gap-2">
        <button
          onClick={() => setMode('email')}
          className={`flex-1 px-3 py-2 rounded flex items-center justify-center gap-2 ${
            mode === 'email' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          }`}
        >
          <Mail className="w-4 h-4" />
          Email
        </button>
        <button
          onClick={() => setMode('sms')}
          className={`flex-1 px-3 py-2 rounded flex items-center justify-center gap-2 ${
            mode === 'sms' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          }`}
        >
          <MessageSquare className="w-4 h-4" />
          SMS
        </button>
      </div>

      {templates.length > 0 ? (
        <>
          <select
            value={selectedTemplate}
            onChange={(e) => setSelectedTemplate(e.target.value)}
            className="w-full border rounded px-3 py-2"
          >
            <option value="">Select template...</option>
            {templates.map((template) => (
              <option key={template.id} value={template.id}>
                {template.name}
              </option>
            ))}
          </select>
          <button
            onClick={handleSend}
            disabled={!selectedTemplate || loading}
            className="w-full bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:bg-gray-400"
          >
            {loading ? 'Sending...' : `Send ${mode.toUpperCase()}`}
          </button>
        </>
      ) : (
        <p className="text-sm text-gray-500 text-center">
          No {mode} templates available for this campaign
        </p>
      )}
    </div>
  );
}


